import premiumDiscoveryPopupComponentUrl from './premiumDiscoveryPopupComponent.html';

class PremiumDiscoveryPopupComponentCtrl {
  constructor(Authentication, PremiumDiscoveryService, SlingAnalytics, $state) {
    'ngInject';

    Object.assign(this, { Authentication, PremiumDiscoveryService, SlingAnalytics, $state });
  }

  $onInit() {
    this.PremiumDiscoveryService.onTrigger(() => {
      if (this.premiumDiscovery._done || this.popupOpened) {
        return;
      }

      this.popupOpened = true;
      this.premiumDiscovery._halted = true;
      return true;
    });
  }

  get features() {
    return this.PremiumDiscoveryService.features;
  }

  get premiumDiscovery() {
    return this.PremiumDiscoveryService.premiumDiscovery;
  }

  get currentFeature() {
    return this.PremiumDiscoveryService.currentFeature;
  }

  discover() {
    const { currentFeature } = this;
    this.premiumDiscovery._halted = false;
    this.premiumDiscovery._lastAutoShow = new Date().toISOString();
    this.PremiumDiscoveryService.featureDiscovered(currentFeature.name);

    this.SlingAnalytics.track(
      this.SlingAnalytics.analyticsEvents.premiumDiscoveryLinkClicked,
      currentFeature.name
    );

    this.popupOpened = false;
    this.$state.go(currentFeature.state, currentFeature.stateParams);
  }

  setCurrentFeature(feature) {
    this.PremiumDiscoveryService.setCurrentFeature(feature);
  }
}

export default {
  templateUrl: premiumDiscoveryPopupComponentUrl,
  controllerAs: 'ctrl',
  controller: PremiumDiscoveryPopupComponentCtrl,
};
